import {
  SHIPPING_LIST_REQUESTING,
  LIST_SHIPPING_SUCCESS,
  RESET_SHIPPING_ISFETCHING,
  RESET_SHIPPING_QUERY
} from './constants';

const INITIAL_STATE = {
  data: null,
  // estimatedDeliveryDateData: null,
  query: null,
  isListFetching: false
  // isFetchingEstimatedShippingDateData: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_SHIPPING_ISFETCHING: {
      return {
        ...state,
        isListFetching: false
      };
    }
    case RESET_SHIPPING_QUERY: {
      return {
        ...state,
        query: null
      };
    }
    case SHIPPING_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_SHIPPING_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        isListFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
